import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Revise({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:900px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; align-items:flex-end; gap:24px;")}>
        <div style={pstyle("display:flex; flex-direction:column; gap:10px; flex:1;")}>
          <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Révision espacée</h1>
          <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Cartes générées depuis le « en bref » de vos fiches. {v.reviseDue}</p>
        </div>
        <div style={pstyle("display:flex; gap:20px;")}>
          {v.reviseStats.map((s, i) => (
            <div key={i} style={pstyle("display:flex; flex-direction:column; gap:2px; text-align:right;")}>
              <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:19px;", { color: s.color })}>{s.value}</span>
              <span style={pstyle("font-size:11.5px; color:oklch(0.53 0.015 60);")}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {v.reviseActive && (
        <div style={pstyle("border:1px solid oklch(0.9 0.01 85); border-radius:10px; padding:32px 34px; display:flex; flex-direction:column; gap:20px; min-height:280px;")}>
          <div style={pstyle("display:flex; align-items:baseline; gap:12px;")}>
            <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; letter-spacing:0.08em; text-transform:uppercase; color:oklch(0.46 0.075 55);")}>{v.cardDomain}</span>
            <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.53 0.015 60);")}>{v.cardBox}</span>
          </div>
          <p style={pstyle("margin:0; font-size:23px; line-height:1.4; letter-spacing:-0.02em; text-wrap:pretty;")}>{v.cardFront}</p>
          {v.cardFlipped && (
            <div style={pstyle("display:flex; flex-direction:column; gap:14px; border-top:1px solid oklch(0.95 0.006 85); padding-top:18px;")}>
              <p style={pstyle("margin:0; font-size:16px; line-height:1.7; color:oklch(0.36 0.015 60); text-wrap:pretty;")}>{v.cardBack}</p>
              <pre style={pstyle("margin:0; padding:12px 14px; background:oklch(0.19 0.012 60); border-radius:7px; font-family:'IBM Plex Mono', monospace; font-size:12.5px; color:oklch(0.9 0.02 90); white-space:pre-wrap;")}>{v.cardSnippet}</pre>
              <button type="button" onClick={v.cardOpen} style={pstyle("background:none; border:none; padding:0; font:inherit; font-size:13.5px; color:oklch(0.46 0.075 55); cursor:pointer;")}>Relire la fiche complète</button>
            </div>
          )}
          <div style={pstyle("margin-top:auto; display:flex; align-items:center; gap:10px; padding-top:8px;")}>
            {v.cardHidden && (
              <button type="button" onClick={v.flipCard} style={pstyle("border:none; font:inherit; font-size:13.5px; background:oklch(0.24 0.012 60); color:oklch(0.98 0.005 85); padding:10px 20px; border-radius:7px; cursor:pointer;")}>Afficher la réponse</button>
            )}
            {v.cardFlipped && v.grades.map((g, i) => (
              <Hoverable key={i} onClick={g.onClick} style={pstyle("font-size:13.5px; border-radius:7px; padding:10px 18px; cursor:pointer;", { border: "1px solid " + g.border, color: g.color })} hoverStyle={{ background: "oklch(0.98 0.006 85)" }}>
                {g.label}
              </Hoverable>
            ))}
            <span style={pstyle("margin-left:auto; font-size:12.5px; color:oklch(0.53 0.015 60);")}>{v.reviseHint}</span>
          </div>
        </div>
      )}

      {v.reviseEmpty && (
        <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:10px; padding:40px; display:flex; flex-direction:column; gap:12px; align-items:flex-start;")}>
          <span style={pstyle("font-size:19px; letter-spacing:-0.015em;")}>Plus rien à revoir aujourd'hui.</span>
          <span style={pstyle("font-size:14.5px; color:oklch(0.5 0.015 60);")}>{v.reviseNext}</span>
          <button type="button" onClick={v.resetRevise} style={pstyle("background:none; border:none; padding:0; font:inherit; font-size:13.5px; color:oklch(0.46 0.075 55); cursor:pointer;")}>Réviser quand même</button>
        </div>
      )}

      <div style={pstyle("display:flex; flex-direction:column; gap:8px;")}>
        <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Votre paquet</div>
        {v.deckRows.map((r, i) => (
          <div key={i} style={pstyle("display:flex; align-items:center; gap:14px; padding:9px 2px; border-bottom:1px solid oklch(0.96 0.006 85); font-size:13.5px;")}>
            <span style={pstyle("color:oklch(0.32 0.015 60); flex:1;")}>{r.title}</span>
            <div style={pstyle("display:flex; gap:4px;")}>
              {r.pips.map((p, pi) => (
                <span key={pi} style={pstyle("width:14px; height:5px; border-radius:2px;", { background: p.bg })}></span>
              ))}
            </div>
            <span style={pstyle("width:120px; text-align:right; font-family:'IBM Plex Mono', monospace; font-size:11.5px;", { color: r.dueColor })}>{r.due}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
